import Immutable, { List } from 'immutable';

import { Image } from '../common/ImageModel';

import genEnum from '../services/genEnum';
import genModel, { FieldSerialization } from '../services/genModel';

export const housingType = genEnum(
  'FLAT',
  'DETACHED_HOUSE',
  'SEMI_DETACHED_HOUSE'
);

export const areaUnits = genEnum(
  'METER',
  'FEET',
  'YARD'
);

export const rentalTypes = genEnum(
  'CONTINUOUS',
  'FIXED_TERM'
);

export const apartmentFeatures = [
  'ACCESSIBLE', 'FURNISHED', 'ELEVATOR', 'WASHING_MACHINE', 'DISHWASHER',
  'BALCONY', 'SAUNA', 'PARKING', 'STORAGE'
];

export const propertyStatus = genEnum(
  'ACTIVE',
  'INACTIVE',
  'DELETED'
);

export class Property extends genModel({
  property_id: { default: '', type: 'string' },
  address: { default: '', type: 'string' },
  latitude: { default: 60.16985569999999, type: 'number' },
  longitude: { default: 24.93837899999994, type: 'number' },
  country: { default: 'FI', type: 'string' },
  housing_type: { default: housingType.FLAT, type: 'enum', enum: housingType },
  apartment_type: { default: 0, type: 'number' },
  area: { default: 0, type: 'number' },
  area_unit: { default: areaUnits.METER, type: 'enum', enum: areaUnits },
  features: { default: List(), type: 'List<string>' },
  rental_type: { default: rentalTypes.CONTINUOUS, type: 'enum', enum: rentalTypes },
  available_from: { default: null, type: 'moment', optional: true },
  description: { default: '', type: 'string' },
  images: {
    default: List(),
    type: 'List<model>',
    model: Image,
    serialization: FieldSerialization.FROM
  },
  status: { default: propertyStatus.INACTIVE, type: 'enum', enum: propertyStatus },
  rent: { default: 0, type: 'number' }
}) {
  genPatch(newProperty) {
    return newProperty
      .toMap()
      .filter((v, k) => {
        if (k === 'images') {
          return true;
        }

        return !Immutable.is(v, this.get(k));
      })
      .update('images', images => images.filter(image => image.blob));
  }

  hasProperAddress(updatedProps = {}) {
    const address = typeof updatedProps.address === 'string' ? updatedProps.address : this.address;
    return address !== Property.fields.address.default;
  }

  hasProperCoordinates(updatedProps = {}) {
    return (updatedProps.latitude || this.latitude) !== Property.fields.latitude.default ||
      (updatedProps.longitude || this.longitude) !== Property.fields.longitude.default;
  }

  locationIsValid(updatedProps = {}) {
    return this.hasProperCoordinates(updatedProps) && this.hasProperAddress(updatedProps);
  }
}
